import { createAsyncThunk } from "@reduxjs/toolkit";
import { storeleVehicleCategoryMaster } from "../../../Api/api";

export const addCategoryMasterAsync=createAsyncThunk(
   "tonnageMaster/add",
   async ({ data, done, err }) => {
         try {
            const response = await storeleVehicleCategoryMaster(data);
            done && done();
            return response.data;
         } catch (error) {
            // You can customize the error handling here
            
            err && err();
            throw error.response.data;
         }
      }
);




